import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Components
import MyNavbar from "./components/Navbar";
import Footer from "./components/Footer";
import HomePage from "./components/HomePage";
import EnrollFormPage from "./pages/userform";
import ContactPage from "./auth/contact";
import CookieConsent from "./components/CookieConsent";
import AdmissionForm from "./admission/admissionpage";
import WhatsAppChatInterface from "./livechat/whatsapp";
import CourseSectionPage from "./components/seven";
import SAPCourses from "./components/sapcoursepage";
import SyllabusCatalog from "./components/syllabuspage";
import ExamPapersHub from "./components/paperdata_previousyears";
import ResumeBuilder1 from "./resumebuilder/resumubuilder";
import CourseBrochureShowcase from "./brochures/coursebrochures";
import CareersPage from "./careers/careerspage";
import JobsPage from "./careers/jobs";
import NEETMedicalPage from "./neet/neet_ug";
import IITJEEPreparationPage from "./iitjee/iit_jeepreparation";
import InternshipApplicationForm from "./intenship/internship";
import InternshipsPage from "./intenship/internships_page";
import SciencePage from './stem/science';
import TechnologyPage from './stem/tech';
import EngineeringPage from './stem/engg';
import EnergyPage from './stem/energy';
import MedicalPage from './stem/medical';
import MathematicsPage from './iitjam/maths';
import IITJAMGeologyPage from "./iitjam/geology";
import GATEAdvancedMathematicsPage from './iitjam/aptitude';
import IITJAMBiotechPage from './iitjam/biotech';
import IITJAMChemistryPage from './iitjam/chemistry';
import IITJAMEconomicsPage from './iitjam/economics';
import IITJAMMathStatPage from './iitjam/statistics';
import ProjectsShowcase from "./projects/projectspage";
import ResumeBuilder from "./resumebuilder/resumepage";
import ResumeBuilder2 from "./resumebuilder/airesume";
import IITJEETraining from './iitjee/iit_training';
import NEETPreparationPage from "./neet/neetpreparation";
import PaidInternshipPage from "./intenship/paid_internship";
import CATraining from './components/ca_program';
import CATrainingIndia from "./ca_programs/ca_national_level";
import CharteredAccountantPlatform from "./ca_programs/ca_international_level";
import StudentDashboard from "./ai_model/course_selector";
import CompleteAcademyDashboard from "./ai_model/course_selector";
import UPSCPage from "./govt_exams/upsc_page";
import SSCPage from "./govt_exams/ssc";
import PSUPage from "./govt_exams/psu_page";
import BankingPage from "./govt_exams/bank_exams";
import RailwaysPage from "./govt_exams/railway_exams";
import ResearchAcademicPage from "./govt_exams/research_page";
import FinanceBankingEconomicsPage from "./govt_exams/finance_page.js";
import DefenceSecurityPage from "./govt_exams/defence_sector.js";
import TechnicalEngineeringPage from "./govt_exams/technical_engineer.js";
import PoliceDefenceSafetyPage from "./govt_exams/police_training.js";
import AgricultureEnvironmentPage from "./govt_exams/agriculture.js";
import SyllabusPage from "./syllabus/syllabus_page.js";
import PreviousYearPapers from "./previouspapers/previous_papers.js";
import AcademyChatbot from "./ai_model/ai_chat.js";
import AIQuestionGenerator from "./ai_model/ai_quesctions-generator.js";
import AITopicGenerator from "./ai_model/ai_topic_generator.js";
import AIAvatarTutor from "./visionstudio/ai_visionpage.js";
import IITJEECatalogue from "./preparation_catalogue/iitjee_catalogue.js";
import NEETMedicalTutor from './visionstudio/ai_vision_neet';
import NEETCatalogue from "./preparation_catalogue/neet_catalogue.js";
import JobsPortal from "./careers/full_time_jobs.js";
import InternshipsPortal from "./intenship/internship_portal.js";
import OlewinApp from "./ai_model/olewin_chat.js";
import AcademyAIChatbot from "./ai_model/ai_chat_bot.js";
import CurrentAffairsPortal from "./govt_exams/current_affairs.js";
import PersonalCoaching from "./pages/personal_training.js";
import GroupTraining from "./pages/group_training.js";
import BeginnerCourses from "./pages/begineer_courses.js";
import CertificatePage from "./pages/certificate_page.js";
import AdvancedCourses from "./pages/advanced_courses.js";
import Mentorship from "./pages/mentorship.js";
import Certifications from "./pages/certication_page.js";
import FAQPage from "./pages/faq.js";
import TermsOfService from "./pages/terms.js";
import PrivacyPolicy from "./pages/privacy.js";
import InstructorApplicationForm from "./instructor/instructorpage.js";
import CompetitiveExamsSection from "./competativesection/compeativeexam_section.js";
import JNVSTPage from "./courses/navodaya.js";
import SainikSchoolPage from "./courses/sainikschool.js";
import CookiesPrivacyPolicy from "./pages/cookiesprefereces.js";
import FeedbackSystem from "./pages/feedback.js";
import ConsultationBooking from "./pages/consultation_page.js";
import GoogleReviewSystem from "./pages/googelreviewsystem.js";
import OlympiadProgramsPage from "./courses/olympiad_pages.js";
import KVPYScholarshipPage from "./courses/kvpy_course.js";
import NTSEScholarshipPage from "./courses/ntse_training_scholarship.js";
import RRBNTPCPage from "./courses/rrb_ntpc.js";
import AIResumeBuilder from "./resumebuilder/resumubuilder";
import BankPOClerkPage from "./courses/bankpo_training.js";
import LawCollegesSection from "./courses/law_training.js";
import OnlineTrainingPage from "./pages/online-training.js";
import ContentCreatorProgram from "./pages/content_creator.js";
import PortfolioStudio from "./portfoliostudio/portfolio_studio.js";
import ManualResumeBuilder from "./resumebuilder/manual_resume.js";
import LearningHub from "./learninghub/learninghub.js";
import CUETExamPage from "./courses/cucet-entrance.js";
import CareersPage1 from "./careers/careers_tech.js";

function App() {
  return (
    
    <Router>
      {/* Always visible widgets */}
      <div>
        {/* Wrapped to prevent crashes if DOM element is missing */}
      
        <WhatsAppChatInterface safeMode />
        <AcademyAIChatbot/>
      </div>
      

      {/* Navbar */}
      <MyNavbar />
   

      {/* Routes */}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/enroll" element={<EnrollFormPage />} />
        <Route path="/register" element={<EnrollFormPage />} />
        <Route path="/admission" element={<AdmissionForm />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/job-oriented-programs" element={<CourseSectionPage />} />
        <Route path="/sap-course" element={<SAPCourses />} />
        <Route path="/syllabus-catalogue" element={<SyllabusCatalog />} />
        <Route path="/previous-papers" element={<ExamPapersHub />} />
        <Route path="/ai_resumepage" element={<AIResumeBuilder />} />
        <Route path="/course_brochures" element={<CourseBrochureShowcase />} />
        <Route path="/careers" element={<CareersPage />} />
        <Route path="/jobs" element={<JobsPage />} />
        <Route path="/full-time-jobs" element={<JobsPortal />} />
        <Route path="/neet" element={<NEETMedicalPage />} />
        <Route path="/iit_jee" element={<IITJEEPreparationPage />} />
        <Route path="/internship_form" element={<InternshipApplicationForm />} />
        <Route path="/internship" element={<InternshipsPage />} />
        <Route path="/company-internships" element={<InternshipsPortal />} />
        <Route path="/stem-science" element={<SciencePage />} />
        <Route path="/stem-technology" element={<TechnologyPage />} />
        <Route path="/stem-engineering" element={<EngineeringPage />} />
        <Route path="/stem-energy" element={<EnergyPage />} />
        <Route path="/stem-medical" element={<MedicalPage />} />
        <Route path="/jam-advanced-mathematics" element={<GATEAdvancedMathematicsPage />} />
        <Route path="/jam-mathematics" element={<MathematicsPage />} />
        <Route path="/jam-geology" element={<IITJAMGeologyPage />} />
        <Route path="/jam-chemistry" element={<IITJAMChemistryPage />} />
        <Route path="/jam-biotechnology" element={<IITJAMBiotechPage />} />
        <Route path="/jam-economics" element={<IITJAMEconomicsPage />} />
        <Route path="/jam-maths_stats" element={<IITJAMMathStatPage />} />
        <Route path="/our_projects" element={<ProjectsShowcase />} />
        <Route path="/resume_builder" element={<ResumeBuilder />} />
        <Route path="/resume_builder2" element={<ResumeBuilder2 />} />
        <Route path="/jee-mains" element={<IITJEETraining />} />
        <Route path="/iit_jee" element={<IITJEEPreparationPage />} />
        <Route path="/neet-ug" element={<NEETMedicalPage />} />
        <Route path="/neet" element={<NEETPreparationPage />} />
        <Route path="/paid_internships" element={<PaidInternshipPage />} />
        <Route path="/ca" element={<CATrainingIndia />} />
        <Route path="/cpa" element={<CharteredAccountantPlatform />} />
        <Route path="/ai-course" element={<CompleteAcademyDashboard />} />
        <Route path="/cpa" element={<CharteredAccountantPlatform />} />
        <Route path="/upsc" element={<UPSCPage />} />
        <Route path="/ssc" element={<SSCPage />} />
        <Route path="/psu-page" element={<PSUPage />} />
        <Route path="/banking-page" element={<BankingPage />} />
        <Route path="/railway-exams" element={<RailwaysPage />} />
        <Route path="/researcher" element={<ResearchAcademicPage/>} />
        <Route path="/finance-sector" element={<FinanceBankingEconomicsPage/>} />
        <Route path="/defense-sector" element={<DefenceSecurityPage/>} />
        <Route path="/technical-engineer" element={<TechnicalEngineeringPage/>} />
        <Route path="/police-training" element={<PoliceDefenceSafetyPage/>} />
        <Route path="/agri-tech" element={<AgricultureEnvironmentPage/>} />
        <Route path="/syllabus" element={<SyllabusPage/>} />
        <Route path="/previous" element={<PreviousYearPapers/>} />
        <Route path="/ai-questions-generator" element={<AIQuestionGenerator/>} />
        <Route path="/ai-topic-generator" element={<AITopicGenerator/>} />
        <Route path="/ai-vision-studio" element={<AIAvatarTutor/>} />
        <Route path="/ai-vision-neet" element={<NEETMedicalTutor/>} />
        <Route path="/iit-jee-catalogue" element={<IITJEECatalogue/>} />
        <Route path="/neet-catalogue" element={<NEETCatalogue/>} />
        <Route path="/current-affairs" element={<CurrentAffairsPortal/>} />
        <Route path="/faqs" element={<FAQPage/>} />
        <Route path="/terms-of-services" element={<TermsOfService/>} />
        <Route path="/privacy" element={<PrivacyPolicy/>} />
        <Route path="/cookies-preferences" element={<CookiesPrivacyPolicy/>} />
        <Route path="/feedback" element={<FeedbackSystem/>} />
        <Route path="/google-reviews" element={<GoogleReviewSystem/>} />
        <Route path="/instructor" element={<InstructorApplicationForm/>} />
        <Route path="/competitive-exams" element={<CompetitiveExamsSection/>} />
        <Route path="/courses/navodaya" element={<JNVSTPage/>} />
        <Route path="/courses/sainik-school" element={<SainikSchoolPage/>} />
        <Route path="/courses/olympiad-training" element={<OlympiadProgramsPage/>} />
        <Route path="/courses/kvpy-training" element={<KVPYScholarshipPage/>} />
        <Route path="/courses/ntse-training" element={<NTSEScholarshipPage/>} />
        <Route path="/courses/rrb-ntpc" element={<RRBNTPCPage/>} />
        <Route path="/courses/bank-po-training" element={<BankPOClerkPage/>} />
        <Route path="/courses/cucet-coaching" element={<CUETExamPage/>} />
        <Route path="/courses/law" element={<LawCollegesSection/>} />
        <Route path="/book-consultation" element={<ConsultationBooking/>} />
        <Route path="/manual-resume" element={<ManualResumeBuilder/>} />
        <Route path="/learning-hub" element={<LearningHub/>} />
        <Route path="/career-tech" element={<CareersPage1/>} />

{/* footer pages  */}
        <Route path="/personal-coaching" element={<PersonalCoaching/>}/>
        <Route path="/group-coaching" element={<GroupTraining/>}/>
        <Route path="/beginner-courses" element={<BeginnerCourses/>}/>
        <Route path="/advance-courses" element={<AdvancedCourses/>}/>
        <Route path="/certifications" element={< CertificatePage/>}/>
        <Route path="/mentorship" element={< Mentorship/>}/>
        <Route path="/certification-courses" element={< Certifications/>}/>
        <Route path="/online-training" element={< OnlineTrainingPage/>}/>
        <Route path="/content-creation" element={< ContentCreatorProgram/>}/>




        <Route path="/olewin-chat" element={<OlewinApp/>}/>
        <Route path="/olewin-portfolio" element={<PortfolioStudio/>}/>
        

      </Routes>

      {/* Footer */}
      <Footer />

      {/* Cookie popup */}
      <CookieConsent safeMode />
    </Router>
  );
}

export default App;


